import { useCallback, useEffect } from 'react'
import { Location, unstable_useBlocker } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { PanesPad } from 'modules/core/components/PanesPad'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import { useLoadingFields } from 'modules/reports/contexts/loadFieldsContext'
import useFields from 'modules/reports/hooks/useFields'
import type { ReportEditorStore } from 'modules/reports/lib/Store'
import { usePromptContext } from 'modules/reports/lib/promptContext'

import { SAVE_ACTION } from '../../SaveReportModal'
import ChartSelector from './FormFields/ChartSelector'
import FormView from './FormView'

interface Props {
  store: ReportEditorStore
}

const Carcasa = ({ store }: Props) => {
  const [promptStatus, setPromptStatus] = usePromptContext()
  const [, setLoadingFields] = useLoadingFields()
  const loadFields = useFields()

  useUnsafeEffect(() => {
    if (store.projection.paths().length) {
      loadFields(
        { projections: store.projection.paths() },
        (status) => setLoadingFields(status),
        (status) => setLoadingFields(status)
      )
    } else {
      loadFields(
        undefined,
        (status) => setLoadingFields(status),
        (status) => setLoadingFields(status)
      )
    }
  }, [store.projection, loadFields, setLoadingFields])

  useEffect(() => {
    setPromptStatus(store.isDirty && !store.saved)
  }, [store.isDirty, store.saved, setPromptStatus])

  const memoized = useCallback(
    (locations: Record<'nextLocation' | 'currentLocation', Location>) => {
      const { nextLocation, currentLocation } = locations

      const nextSearchParams = new URLSearchParams(nextLocation.search)
      const currentSearchParams = new URLSearchParams(currentLocation.search)

      if (
        nextLocation.search == currentLocation.search &&
        nextLocation.pathname == currentLocation.pathname
      ) {
        return false
      }

      if (
        currentSearchParams.get('action') == SAVE_ACTION &&
        nextSearchParams.get('action') == null
      ) {
        return false
      }

      if (nextSearchParams.get('action') == SAVE_ACTION) {
        return false
      }

      if (promptStatus) {
        return !window.confirm(i18n.t('common.confirm_navigation'))
      }

      return false
    },
    [promptStatus]
  )

  unstable_useBlocker(memoized)

  return (
    <PanesPad>
      <Box flexDirection="column" gap="s24">
        <Box flexDirection="column">
          <ChartSelector store={store} />
          <FormView store={store} />
        </Box>
      </Box>
    </PanesPad>
  )
}

export default observer(Carcasa)
